import { Step } from '../../../../../views/alerts/PendingOrderAlertScreen';
import { BackendErrorCode, OrderMethod } from '../../../../../services/exports/Constants';

export default {
  steps: {
    [Step.OrderPreview]: {
      titles: {
        asap: 'Uusi {{method}}-tilaus!',
        scheduled: 'Ajastettu {{method}}-tilaus!',
        on_site: 'Uusi pöytätilaus!',
        // Table orders are ASAP; this is for room-service orders scheduled before the rename.
        on_site_scheduled: 'Ajastettu pöytätilaus!',
      },
      labels: {
        today: 'tänään',
        time_remaining_to_accept: 'aikaa hyväksyä',
      },
      time_tag: {
        [OrderMethod.Pickup]: {
          asap: '🕓 Nouto {{time}} kuluttua',
          scheduled: '🕓 Nouto {{day}} klo {{time}}',
          scheduled_today: '🕓 Nouto tänään klo {{time}}',
        },
        [OrderMethod.Delivery]: {
          asap: '🕓 Toimitus {{time}} kuluttua',
          scheduled: '🕓 Toimitus {{day}} klo {{time}}',
          scheduled_today: '🕓 Toimitus tänään klo {{time}}',
        },
        [OrderMethod.OnSite]: {
          // No 🕓: the screen draws the design's clock icon for table orders.
          asap: 'Tarjoilu {{from}}–{{to}} min kuluttua',
          scheduled: 'Tarjoilu {{day}} klo {{time}}',
          scheduled_today: 'Tarjoilu tänään klo {{time}}',
        },
      },
      time_tag_estimated: {
        asap: '🕓 Arvioitu noutoaika: {{time}}',
        scheduled: '🕓 Arvioitu noutoaika: {{day}} klo {{time}}',
      },
      buttons: {
        confirm_order: 'Vahvista tilaus',
        cancel_order: 'Peruuta tilaus',
      },
      feedback: {
        rough_estimate_warning:
          'Tämä on vain karkea arvio. Saat varsinaisen valmisteluajan, kun kuljettaja on määritetty ja toimitusaika vahvistettu. Silloin kuittisi tulostuu automaattisesti.',
      },
    },
    [Step.OrderConfirmation]: {
      title: 'Valmisteluaika',
      labels: {
        today: 'tänään',
        order_time: {
          [OrderMethod.Delivery]: {
            asap: 'Toimitus',
            scheduled: 'Toimitus',
            scheduled_today: 'Toimitus',
          },
          [OrderMethod.Pickup]: {
            asap: 'Nouto',
            scheduled: 'Nouto',
            scheduled_today: 'Nouto',
          },
          [OrderMethod.OnSite]: {
            asap: 'Tarjoilu',
            scheduled: 'Tarjoilu',
            scheduled_today: 'Tarjoilu',
          },
        },
        can_you_make_it: 'Onnistuuko?',
        we_also_send_this_update_to_the_customer: 'Lähetämme tämän päivityksen myös asiakkaalle',
      },
      buttons: {
        yes_lets_go: 'Kyllä, mennään!',
        no_change_time: 'Ei, vaihda aikaa',
        confirm: 'Vahvista',
      },
      toasts: {
        order_confirmed: {
          title: 'Tilaus #{{number}} vahvistettu',
          body: 'Älä valmista vielä! Ilmoitamme, kun kuljettaja on määritetty.',
        },
        [BackendErrorCode.NoDeliveryQuotesAvailable]:
          'Valitettavasti toimitus täytyy perua, koska kuljettajaa ei ole saatavilla. Napsauta oikeassa yläkulmassa olevaa kolmea pistettä peruuttaaksesi tilauksen ja palauttaaksesi rahat asiakkaalle',
        [BackendErrorCode.DeliveryProviderException]:
          'Valitettavasti toimitus täytyy perua, koska kuljettajaa ei ole saatavilla. Napsauta oikeassa yläkulmassa olevaa kolmea pistettä peruuttaaksesi tilauksen ja palauttaaksesi rahat asiakkaalle',
        [BackendErrorCode.DeliveryDispatchRetrying]:
          'Tilaus hyväksytty, mutta kuljettajaa ei ole vielä varattu. Yritämme 15 minuutin ajan ja ilmoitamme, jos kuljettajaa ei löydy.',
      },
    },
  },
  error_messages: {
    something_went_wrong: 'Jokin meni pieleen, yritä uudelleen',
  },
};
